module.exports = __webpack_public_path__ + "static/media/gauge.f2998a7c.svg";